
import { defineComponent, computed, PropType } from "vue";

interface SmsPackage {
  package_id: number;
  sms_count: number;
  usage: number;
  activated_date: string;
  status: string;
}

export default defineComponent({
  name: "SMSPackageDialog",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    smsPackages: {
      type: Array as PropType<SmsPackage[]>,
      required: true,
    },
    totalSMSCount: {
      type: Number,
      required: true,
    },
    totalUsage: {
      type: Number,
      required: true,
    },
    totalRemainingSMS: {
      type: Number,
      required: true,
    },
    activePackagesCount: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:visible"],
  
  setup(props, { emit }) {
    const dialogVisible = computed({
      get() {
        return props.visible;
      },
      set(value) {
        emit("update:visible", value);
      },
    });

    return {
      dialogVisible,
    };
  },
});
